import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const ResourcesSubmenu = () => {
    return (
        <div className="submenu">
            <ul>
                <li>
                    <Link to="/blog">Blog</Link>
                </li>
                <li>
                    <Link to="/changelog">Changelog</Link>
                </li>
                <li>
                    <Link to="/knowledge-hub">
                        <FormattedMessage
                            id="ResourcesSubmenu.knowledgeHub"
                            defaultMessage="Knowledge Hub"
                        />
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default ResourcesSubmenu;
